import React from "react";

function Services() {
  return (
    <section id="services" style={{ padding: "20px" }}>
      <h2
        style={{
          textAlign: "center",
          fontSize: "2rem",
          fontWeight: "bold",
          marginBottom: "30px",
          color: "#333",
          textTransform: "uppercase", // Make the title unique
          borderBottom: "2px solid #ffd700", // Add a unique underline
          display: "inline-block",
          paddingBottom: "10px",
        }}
      >
        Санал болгож буй үйлчилгээ
      </h2>
      <div
        className="service-container"
        style={{
          display: "flex",
          flexWrap: "wrap", // Allow wrapping to fit items
          gap: "20px",
          justifyContent: "center",
        }}
      >
        {/* First 5 Short Services */}
        <div
          className="service-item"
          style={{
            flex: "1 1 calc(20% - 20px)", // Adjust width to fit 5 items per row
            maxWidth: "200px",
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            color: "#000000",
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            height: "150px", // Short height
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h3 style={{ fontSize: "1rem", marginBottom: "5px" }}>ХУУЛЬ, ЭРХ ЗҮЙ</h3>
          <p style={{ fontSize: "0.8rem", color: "#555" }}>Law, Legal</p>
        </div>
        <div
          className="service-item"
          style={{
            flex: "1 1 calc(20% - 20px)",
            maxWidth: "200px",
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            height: "150px", // Short height
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h3 style={{ fontSize: "1rem", marginBottom: "5px" }}>
            ТАТВАР, АУДИТ САНХҮҮГИЙН ХЯНАЛТ
          </h3>
          <p style={{ fontSize: "0.8rem", color: "#555" }}>
            Tax, Audit, Financial Control
          </p>
        </div>
        <div
          className="service-item"
          style={{
            flex: "1 1 calc(20% - 20px)",
            maxWidth: "200px",
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            height: "150px", // Short height
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h3 style={{ fontSize: "1rem", marginBottom: "5px" }}>
            АЛБАН ХЭРЭГ ХӨТЛӨЛТ
          </h3>
          <p style={{ fontSize: "0.8rem", color: "#555" }}>Office Management</p>
        </div>
        <div
          className="service-item"
          style={{
            flex: "1 1 calc(20% - 20px)",
            maxWidth: "200px",
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            height: "150px", // Short height
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h3 style={{ fontSize: "1rem", marginBottom: "5px" }}>
            СЭТГЭЛ ЗҮЙН ЗӨВЛӨГӨӨ
          </h3>
          <p style={{ fontSize: "0.8rem", color: "#555" }}>
            Psychological Counseling
          </p>
        </div>
        <div
          className="service-item"
          style={{
            flex: "1 1 calc(20% - 20px)",
            maxWidth: "200px",
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            height: "150px", // Short height
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h3 style={{ fontSize: "1rem", marginBottom: "5px" }}>
            БАРИМТ БИЧИГ БОЛОВСРУУЛАЛТ
          </h3>
          <p style={{ fontSize: "0.8rem", color: "#555" }}>
            Document Processing
          </p>
        </div>

        {/* Last 3 Detailed Services */}
        <div
          className="service-item"
          style={{
            flex: "1 1 calc(50% - 20px)", // Adjust width for detailed services
            maxWidth: "500px",
            textAlign: "left",
            backgroundColor: "#ffffff",
            color: "#000000",
            padding: "15px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h3 style={{ fontSize: "1.2rem", marginBottom: "10px" }}>
            Өмгөөллийн үйлчилгээ
          </h3>
          <ul style={{ fontSize: "0.9rem", color: "#555", paddingLeft: "20px" }}>
            <li>Эрүүгийн хэрэг хянан шийдвэрлэх ажиллагаанд үйлчлүүлэгчийг төлөөлөх, өмгөөлөгчөөр оролцох</li>
            <li>Зөрчлийн хэрэг, зөрчил хянан шийдвэрлэх ажиллагаанд үйлчлүүлэгчийг төлөөлөх, өмгөөлөгчөөр оролцох</li>
            <li>Иргэний хэрэг хянан шийдвэрлэх ажиллагаанд нэхэмжлэгч, хариуцагч, гуравдагч этгээдийг төлөөлөх, өмгөөлөгчөөр оролцох</li>
            <li>Захиргааны хэрэг хянан шийдвэрлэх ажиллагаанд нэхэмжлэгч, хариуцагч, гуравдагч этгээдийг төлөөлөх, өмгөөлөгчөөр оролцох</li>
            <li>Олон улсын шүүх, арбитрын ажиллагаа болон бусад төрийн болон хувийн хэвшлийн байгууллага, үйлчлүүлэгчийг төлөөлөх</li>
          </ul>
        </div>

        <div
          className="service-item"
          style={{
            flex: "1 1 calc(50% - 20px)", // Adjust width for detailed services
            maxWidth: "500px",
            textAlign: "left",
            backgroundColor: "#ffffff",
            color: "#000000",
            padding: "15px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h3 style={{ fontSize: "1.2rem", marginBottom: "10px" }}>
            Хууль зүйн туслалцаа
          </h3>
          <ul style={{ fontSize: "0.9rem", color: "#555", paddingLeft: "20px" }}>
            <li>Хуулийн төсөл боловсруулах</li>
            <li>Захиргааны хэм хэмжээний актын төсөл боловсруулах</li>
            <li>Хууль зүйн асуудлаар амаар болон бичгээр зөвлөгөө өгөх</li>
            <li>Хууль зүйн ач холбогдол бүхий баримт бичгийн эх боловсруулах, хянах</li>
            <li>Өргөдөл, гомдол, нэхэмжлэл, гэрээ, тушаал зэрэг баримт бичгийн эх боловсруулах</li>
            <li>Хохирол барагдуулахад чиглэсэн аливаа зөвшилцөл, эвлэрүүлэн зуучлах үйл ажиллагааг явуулах</li>
            <li>Гуравдагч этгээдэд зориулсан хууль зүйн дүгнэлт өгөх</li>
            <li>Тодорхой сэдвийн хүрээнд хууль зүйн сургалт зохион байгуулах</li>
          </ul>
        </div>

        <div
          className="service-item"
          style={{
            flex: "1 1 calc(50% - 20px)", // Adjust width for detailed services
            maxWidth: "500px",
            textAlign: "left",
            backgroundColor: "#ffffff",
            color: "#000000",
            padding: "15px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h3 style={{ fontSize: "1.2rem", marginBottom: "10px" }}>
            Татвар, аудит, санхүүгийн хяналт
          </h3>
          <ul style={{ fontSize: "0.9rem", color: "#555", paddingLeft: "20px" }}>
            <li>Татвар, нийгмийн даатгалын тухай хууль, сангийн сайдын тушаал, бусад төрийн байгууллагуудаас гаргаж байгаа журам, зааварчилгааг хэрэгжүүлэхтэй холбогдуулан мэргэжлийн туслалцаа, зөвлөгөө өгөх</li>
            <li>Татвар, нийгмийн даатгалын хууль тогтоомжийн талаар сургалт явуулах, мэдээлэл өгөх</li>
            <li>Татвар, санхүүгийн тайлан, нягтлан бодох бүртгэлийн хөтөлбөр, нийгмийн даатгалын тайланд хяналт тавих, зөвлөгөө өгөх</li>
            <li>Тооцоолол хийхэд санал зөвлөмж өгөх</li>
            <li>Санхүүгийн төлөвлөгөө, нягтлан бодох бүртгэлтэй холбоотой зөвлөгөө, үйлчилгээ үзүүлэх мэргэжлийн дүгнэлт өгөх</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Services;